import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

// Keep these Q&As in sync with the FAQPage JSON-LD in public/index.html —
// Google requires the visible content to match the structured data.
const FAQS = [
  {
    q: "What services does PickNGo Swift offer?",
    a: "PickNGo Swift offers same-city bike courier delivery, room and office shifting, luggage shifting for students, small furniture moves, intercity hub-routed parcel delivery, and B2B express logistics, with live tracking and transparent slab-based pricing.",
  },
  {
    q: "How is the delivery price calculated?",
    a: "Every booking uses a transparent slab-based formula: a per-kg base price by weight slab (0–1 kg, 1–2 kg, … up to 30 kg), combined with a distance-based component, plus service charges (pickup, packing, platform, hub) and applicable GST. You see the exact breakdown before you pay — no hidden fees.",
  },
  {
    q: "Do you charge for packing?",
    a: "Yes — professional packing is bundled into the service charges shown on the quote. Packing fees are size-tiered (small / medium / large) and visible in the quote breakdown before you confirm the booking.",
  },
  {
    q: "Which cities does PickNGo Swift serve?",
    a: "PickNGo Swift is expanding across India. Same-city services are currently available in selected cities, while intercity deliveries are supported through partner courier and hub networks.",
  },
  {
    q: "Can I pay on delivery (COD)?",
    a: "Yes, Cash on Delivery is supported for every service type. You can also pay online via UPI, credit/debit card, net banking, or wallet through our secure Razorpay checkout.",
  },
  {
    q: "How do I track my shipment?",
    a: "Every booking gets a tracking ID. You can track shipment status at pickngo.co.in/track or via the link in your booking confirmation.",
  },
  {
    q: "How is delivery verified?",
    a: "All deliveries are verified with a 6-digit OTP generated at pickup. The recipient shares the OTP with the delivery agent at the doorstep to confirm handover — no signature spoofing, no mis-deliveries.",
  },
  {
    q: "What if my package is damaged?",
    a: "PickNGo Swift provides a damage protection mechanism. If your package arrives damaged, you can file a claim with photos from your dashboard within the allowed window. Approved claims are processed as per policy.",
  },
];

export default function HomeFAQ() {
  return (
    <section className="py-16 sm:py-20 bg-white" id="faq" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-orange-50 border border-orange-200 rounded-full mb-4">
            <HelpCircle className="h-4 w-4 text-[#FF6B00]" />
            <span className="text-sm font-semibold text-[#FF6B00]">FAQ</span>
          </div>
          <h2 className="font-['Outfit'] text-2xl sm:text-3xl font-bold text-slate-900">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-slate-500 mt-2">Everything you need to know before booking your first pickup</p>
        </div>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={`faq-${i}`}
              value={`faq-${i}`}
              className="bg-slate-50/60 border border-slate-100 rounded-2xl px-5 data-[state=open]:bg-white data-[state=open]:shadow-sm data-[state=open]:border-orange-100 transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-sm sm:text-[15px] font-semibold text-slate-900 hover:no-underline py-4" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-4">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
